module.exports = __webpack_public_path__ + "static/media/hak-media.90bc5531.png";